import React, { useEffect, useState } from 'react'
import { BackgroundLoading, StyledDiv, IconDiv } from './audio-intro.styled';
import { SpinnerComponent } from './spinner.component';
import { FaHeadphonesAlt } from 'react-icons/fa';
import { useResize } from '../../hooks'
import { Text } from '../'
import { COLOR, FONT } from '../../assets'

const AudioIntroComponent = () => {
  const isMobile = useResize().isMobile;
  const heightSize = useResize().height;

  const minPercent = .7;

  const [ heightPercent, setHeightPercent ] = useState(1);

  useEffect(() => {

    if(isMobile) {
      setHeightPercent(1)
    } else {
      let percent = heightSize / 900;
      
      if(percent < 1) {
        if(percent < minPercent) percent = .6;
        setHeightPercent(percent);
      } else {
        if(percent !== 1){
          setHeightPercent(1);
        }
      }
    }

     
  }, [isMobile, heightSize]);

  return (
    <BackgroundLoading>
      <StyledDiv style={{ transform: heightPercent !== 1 && `scale(${heightPercent})`}}>
        <SpinnerComponent mobile={isMobile} />
        <Text 
          color="#fff"
          fontFamily="Amorim Sans Book"
          textTransfor="normal"
          fontSizeMobile={FONT.sm3}
          fontSize={FONT.md3}
          textId="audio-intro.title"
        />
        <Text
          color={COLOR.quaternary}
          textTransfor="normal"
          fontFamily="Amorim Sans Book"
          fontSizeMobile={FONT.sm2}
          fontSize={FONT.md2}
          textId="audio-intro.subtitle"
        />
        <IconDiv mobile={isMobile}>
          <FaHeadphonesAlt fill={COLOR.quaternary} size={ isMobile ? '2em' : '3em'}  />
        </IconDiv>
      </StyledDiv>
    </BackgroundLoading>
  );
} 



export default React.memo(AudioIntroComponent);
